import { gql } from "@apollo/client";

export const ADD_DOCUMENTO_COTIZACION = gql`
    mutation uploadCotizacion(
        $idEvaluacion: Int!,
        $contentType: String!,
        $titulo: String!,
        $archivo: [Byte!]!,
        $extension: String!
    ){
        uploadCotizacion(
            idEvaluacion: $idEvaluacion,
            contentType: $contentType,
            titulo: $titulo,
            archivo: $archivo,
            extension: $extension
        ) 
    }
`;